import React from 'react';
import { Text } from '@/components/ui/text';

export interface PresentationCaptionProps {
  caption?: string | null;
}

/**
 * Small muted heading rendered above a presentation card when the tool payload
 * provides a `caption`. Mirrors the per-group caption used by WorkoutListCard.
 */
export const PresentationCaption: React.FC<PresentationCaptionProps> = ({
  caption,
}) => {
  if (!caption) {
    return null;
  }

  return <Text className="text-sm text-text-secondary px-1">{caption}</Text>;
};
